export const mapAuthErrorToMessage = (errorCode: string): string => {
  const errorMap: { [key: string]: string } = {
    'auth/invalid-email': 'Please enter a valid email address.',
    'auth/user-disabled': 'This account has been disabled.',
    'auth/user-not-found':
      'No account was found with this email. Use register to create an account.',
    'auth/wrong-password':
      'Your password is incorrect. Please check for typos and try again, or reset your password if you have forgotten it.',
    'auth/too-many-requests':
      'Too many failed attempts. Please try again later.',
    'auth/network-request-failed':
      'Network error. Please check your connection.',
    'auth/operation-not-allowed': 'This operation is not allowed.',
    'auth/email-already-in-use':
      'This email is already registered, please login, or reset your password if you have forgotten it.',
    'auth/weak-password': 'Password is too weak',
    'auth/invalid-credential':
      'Invalid email or password. Please check for typos and try again, or reset your password if you have forgotten it.',
  };

  return (
    errorMap[errorCode] || 'An unexpected error occurred. Please try again.'
  );
};
